import { render } from "./9Notices.vue?vue&type=template&id=731924f3&scoped=true"
import script from "./9Notices.vue?vue&type=script&lang=js"
export * from "./9Notices.vue?vue&type=script&lang=js"

import "./9Notices.vue?vue&type=style&index=0&id=731924f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731924f3"]])

export default __exports__